const cListDropdownImageInit = () => {

    const init = (box) => {
        if(!box) return 1;

        let animating = false;
        let mouseOver = false;
        let play = true;
        let progress = 0;
        let timer;
        let time = Number(window.LIST_DROPDOWN_IMAGE_SLIDE_SPEED) || 5000;
        let fps = 1000/25;
        let step = (fps/time) * 100;

        if(window.innerWidth < 1024){
            play = false;
        }

        window.onresize = (e) => {
            if(window.innerWidth < 1024){
                play = false;
            } else{
                play = true;
                autoplay();
            }
        };

        let item = box.querySelector('.c-ldi-list .item');
        let image = box.querySelector('.c-ldi-image figure');
        if(item){
            item.classList.add('active','show');
            slideDown(item.querySelector('.content'));
        }
        if(image){
            fadeIn(image);
        }

        let list = box.querySelectorAll('.c-ldi-list .item');
        let list_count = list.length;
        if(list_count > 0){
            for(let i = 0; i < list_count; i++){
                list[i].addEventListener("click", listClick);
                list[i].addEventListener("mouseenter", (e) => {
                    if(list[i].classList.contains('active')){
                        mouseOver = true;
                    }
                });
                list[i].addEventListener("mouseleave", (e) => {
                    if(list[i].classList.contains('active')){
                        mouseOver = false;
                    }
                });
            }
        }

        function autoplay () {
            if(!play){
                return 1;
            }
            if(!mouseOver){
                progress += step;
            }
            let loader = box.querySelector('.c-ldi-list .active .loader span');
            if(loader){
                loader.style.width = progress + '%';
            }
            if(progress < 100){
                timer = setTimeout(autoplay, fps);
            } else {
                next();
                clearTimeout(timer);
            }
        };

        function listClick() {
            if(animating || this.classList.contains('active')){
                return 1;
            }
            animating = true;
            let el = this;
            let progbar = el.querySelector('.loader span');
            progbar.style.width = 0 + '%'
            let active = box.querySelector('.c-ldi-list .item.active');
            show(el);
            if(active){
                hide(active);
            }
        }

        function next() {
            if(animating){
                return 1;
            }
            animating = true;
            let active = box.querySelector('.c-ldi-list .item.active');
            if(active){
                let new_index = +active.dataset.index + 1;
                let next = box.querySelector('.c-ldi-list .item[data-index="' + new_index + '"]');
                if(!next){
                    new_index = 1;
                }
                next = box.querySelector('.c-ldi-list .item[data-index="' + new_index + '"]');
                if(next){
                    show(next);
                    hide(active);
                }
            }

        }

        function show(el) {
            if(!el) return 1;
            el.classList.add('active','show');
            let index = el.dataset.index;
            let image = box.querySelector('.c-ldi-image figure[data-index="' + index + '"]');
            fadeIn(image);
            slideDown(el.querySelector('.content'));
            progress = 0;
            clearTimeout(timer);
        }

        function hide(el) {
            if(!el) return 1;
            let index = el.dataset.index;
            let image = box.querySelector('.c-ldi-image figure[data-index="' + index + '"]');
            el.classList.remove('show');
            slideUp(el.querySelector('.content'));
            fadeOut(image);
        }

        function slideDown(el) {
            if(!el) return 1;
            el.style.height = "auto";
            let height = el.clientHeight + "px";
            el.style.height = "0px";
            setTimeout(() => {
                el.style.height = height;
            }, 0);
        }

        function slideUp(el) {
            el.style.height = "0px";

            el.addEventListener('transitionend', () => {
                el.closest('.item').classList.remove('active');
                animating = false;
                autoplay();
            }, {once: true})
        }

        function fadeIn(el){
            if(!el) return 1;
            el.style.display = 'block';
        }

        function fadeOut(el){
            if(!el) return 1;
            el.style.display = 'none';
        }

        autoplay();
    };


    let box = document.querySelectorAll('.c-list-dropdown-image');
    let count = box.length;
    if(count > 0){
        for(let i = 0; i < count; i++){
            init(box[i]);
        }
    }

};

export default cListDropdownImageInit
